import script from "./DialogFinalizeDocument.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogFinalizeDocument.vue?vue&type=script&setup=true&lang=ts"

import "./DialogFinalizeDocument.vue?vue&type=style&index=0&id=8e9ab67c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e9ab67c"]])

export default __exports__